export const unProtectedRoutes = [
  "login",
  "forgot-password",
  "reset-password",
  "check-reset",
];
